import React from 'react';
import { Link } from 'react-router-dom';
import Disclaimer from './Disclaimer';
import PublicSiteFooter from './PublicSiteFooter';
import './InfoPages.css';

const AGREEMENT_HIGHLIGHTS = [
  {
    title: 'Linked documents',
    detail: 'This agreement points to the Terms of Service and Privacy Policy so the legal stack stays easy to navigate.',
  },
  {
    title: 'Commercial path',
    detail: 'Paid or enterprise terms belong in the order form or separate enterprise agreement, not the free launch copy.',
  },
  {
    title: 'Simple promise',
    detail: 'Users are not charged during the current beta launch, and the agreement says that plainly.',
  },
];

function UserAgreement({ theme = 'dark' }) {
  const isDark = theme === 'dark';
  return (
    <div className={`info-page-shell ${isDark ? 'info-page-dark' : 'info-page-light'}`}>
      <div className="info-page-card">
        <header className="info-page-header">
          <div className="info-page-badge">Legal</div>
          <h1>User Agreement</h1>
          <Disclaimer>
            <strong>Beta / Free Tier Disclaimer:</strong> Redacto is currently in a FREE launch / beta phase. Billing and paid subscription features are disabled at present. This launch does not obligate users to any charges.
          </Disclaimer>
        </header>

        <div className="info-page-body info-page-body-readable">
          <div className="info-page-lead-card info-page-agreement-lead">
            <div className="info-page-section-kicker">Quick read</div>
            <h2>The agreement ties the product, privacy, and commercial terms together.</h2>
            <p>
              It gives users a short entry point before they move into the full Terms of Service and Privacy Policy.
            </p>
          </div>

          <div className="info-page-grid info-page-highlight-grid" aria-label="Agreement highlights">
            {AGREEMENT_HIGHLIGHTS.map((card) => (
              <article key={card.title} className="info-page-panel info-page-highlight-panel">
                <h3>{card.title}</h3>
                <p>{card.detail}</p>
              </article>
            ))}
          </div>

          <p>
            The User Agreement references the Redacto <Link to="/terms">Terms of Service</Link> and <Link to="/privacy-policy">Privacy Policy</Link>.
            By using Redacto you agree to these documents. During the current free launch, billing features are disabled and
            users will not be charged.
          </p>

          <p>
            For enterprise or paid deployments, the order form or separate enterprise agreement will govern commercial terms.
            Contact info@redacto.net for enterprise inquiries.
          </p>

          <p><strong>End of Agreement</strong></p>
        </div>
      </div>
      <PublicSiteFooter />
    </div>
  );
}

export default UserAgreement;
